import { TextInput } from "@/shared/components/form/text-input";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { inputValidationErrorMessages } from "@/shared/components/errors/input-error-messages";
import { PutRequest } from "@/services/backend/htz/ahu/api/ahu-api";

/**
 * AhuBaseDataCard is a card component that displays the basic data of an
 * air handling unit (AHU) and allows editing it. It takes a PutRequest object
 * as a prop, which contains the current data of the AHU, and a callback function
 * onRequestChange that is called when the data is changed. It also takes an error
 * prop to display validation errors.
 */
export function AhuBaseDataCard({
  request,
  onRequestChange,
  error,
}: {
  request: PutRequest;
  onRequestChange: (request: PutRequest) => void;
  error: unknown;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Basisdaten")}</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4">
        <TextInput
          label={t("Name")}
          field="name"
          text={request.name}
          onTextChange={(name) => onRequestChange({ ...request, name })}
          errors={inputValidationErrorMessages(error, "name")}
        />
      </CardContent>
    </Card>
  );
}
